import React from 'react'
import { Button, Modal } from '@/shared/ui'
import { ArrowRight } from 'lucide-react'

export type PlanExpiredNoticeModalProps = {
  open: boolean
  planLabel?: string | null
  onDismiss: () => void
  onRenew: () => void
}

export default function PlanExpiredNoticeModal({ open, planLabel, onDismiss, onRenew }: PlanExpiredNoticeModalProps) {
  const title = 'Sua assinatura venceu'
  const planText = planLabel ? `do plano ${planLabel}` : 'do seu plano'
  return (
    <Modal open={open} onOpenChange={(v) => { if (!v) onDismiss() }} className="max-w-[560px] p-6">
      <div className="text-lg font-semibold">{title}</div>
      <p className="mt-3 text-sm text-foreground/80">
        Sua assinatura {planText} venceu e você foi migrado automaticamente para o Freemium.
        Você continua com acesso limitado e pode renovar quando quiser para recuperar todos os recursos.
      </p>
      {planLabel && (
        <div className="mt-3 text-xs text-foreground/60">
          Plano anterior: {planLabel}
        </div>
      )}
      <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <Button variant="outline" onClick={onDismiss}>
          Continuar no Freemium
        </Button>
        <Button onClick={onRenew} className="gap-2">
          Renovar assinatura
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </Modal>
  )
}
